export default "__VITE_ASSET__20476389__"